import {OptionItem} from '../../../types';
import {FilterState} from './IssueFilters';

// Every stored filter option carries `type = <groupKey>` so group membership
// is reliable regardless of the aggregation item shape.

// Values currently selected for a given filter group key.
export const getGroupSelectedValues = (filters: FilterState, key: string): string[] =>
  filters.options
    .filter(opt => opt.type === key || opt.identified === key || opt.tableName === key)
    .map(opt => opt.id || opt.value || opt.description || '');

// Merge a group's new selection back into filters.options, replacing that group's entries.
export const mergeGroupSelection = (
  filters: FilterState,
  key: string,
  optionItems: OptionItem[],
  values: string[]
): OptionItem[] => {
  const newForCategory: OptionItem[] = values.map(value => {
    const original = optionItems.find(
      opt => (opt.id || opt.value || opt.description) === value
    );

    if (key === 'status' || key === 'impact') {
      return {identified: key, type: key, id: value, description: original?.description};
    }

    return {...(original || {value}), type: key};
  });

  const otherOptions = filters.options.filter(
    opt => !(opt.type === key || opt.identified === key || opt.tableName === key)
  );
  return [...otherOptions, ...newForCategory];
};
